import { toast, Zoom } from 'react-toastify';

export const INTERNAL_CHAT_TOAST_CONTAINER_ID = 'internal-chat';
export const INTERNAL_CHAT_TOAST_WRAPPER_CLASS = 'internal-chat-toasts';

/** O chat interno aparece em todas as páginas, mas não existe `ToastContainer` global:
 *  cada página monta o seu, e um container comum mostra todos os avisos. Por isso o
 *  chat tem um container próprio, que só mostra os avisos endereçados a ele
 *  (`enableMultiContainer`). Quando a página já tem um container, o aviso vai sem
 *  `containerId` e aparece só no dela; senão, vai para o do chat. Assim ele aparece
 *  sempre, e uma vez só.
 */
const hasPageToastContainer = () => {
    return Array.from(document.querySelectorAll('.Toastify'))
        .some(element => !element.closest(`.${INTERNAL_CHAT_TOAST_WRAPPER_CLASS}`));
}

const buildOptions = () => ({
    transition: Zoom,
    ...(hasPageToastContainer() ? {} : { containerId: INTERNAL_CHAT_TOAST_CONTAINER_ID })
});

const internalChatToast = {
    success: (message) => toast.success(message, buildOptions()),
    error: (message) => toast.error(message, buildOptions()),
    info: (message) => toast.info(message, buildOptions())
};

export default internalChatToast;
